import axios from 'axios';

import { API_URL, WLID, DID, ADID } from '../config/constants';

import setAuthHeader from '../utils/setAuthHeader';
import { deliveryAddressFormLoading, deliveryAddressFormError, deliveryAddressFormReset } from './deliveryAddressForm';
import { cartInfoUpdate } from './cart';
import { setAccountPanel, setCartPanel } from './panels';
import { setHistoryPanel } from '../actions/panels';

export const viewLogin = () => {
    return {
        type: 'VIEW_LOGIN'
    };
};

export const viewRegister = () => {
    return {
        type: 'VIEW_REGISTER'
    };
};

export const viewForgotPassword = () => {
    return {
        type: 'VIEW_FORGOT_PASSWORD'
    };
};

export const authUserUpdate = ({ prop, value }) => {

    return {
        type: 'AUTH_USER_UPDATE',
        field: { prop, value }
    }
};

export const authFormUpdate = ({ prop, value }) => {

    return {
        type: 'AUTH_FORM_UPDATE',
        field: { prop, value }
    }
};

export const authSuccess = (token, userInfo) => {
    return {
        type: 'AUTH_SUCCESS',
        token,
        userInfo
    };
};

export const authUpdateUserAddresses = (addresses) => {
    return {
        type: 'AUTH_UPDATE_USER_ADDRESSES',
        addresses
    };
};

export const resetPasswordSuccess = () => {
    return {
        type: 'RESET_PASSWORD_SUCCESS'
    };
};

export const authError = (message) => {
    return {
        type: 'AUTH_ERROR',
        error: message
    };
}

export const authLoading = () => {
    return {
        type: 'AUTH_LOADING'
    };
}

export const authLoadingOff = () => {
    return {
        type: 'AUTH_LOADING_OFF'
    };
}

export const validateLogin = ({ token }) => {

    return (dispatch) => {

        dispatch(authLoading());

        // prepare the auth string
        let authData = {
            token
        };

        if (WLID != 0) {
            authData.wlid = WLID;
        }
        if (DID != 0) {
            authData.did = DID;
        }
        if (ADID != 0) {
            authData.adid = ADID;
        }

        // login our user
        axios.post(API_URL+'/api/checktoken', authData)
            .then(function(res) {
                if (res.data.status == "success") {
                    window.localStorage.removeItem("currentOrderKey");
                    dispatch(authSuccess(token, res.data.data.userInfo));
                    // Actions.main();
                }
                else {
                    dispatch(authError(res.data.message));
                }
            })
            .catch(function(err) {
                dispatch(authError(""));
            });
    };
};

export const loginUser = ({ email, password, history, redirectTo=false, location_id=0, sitename='' }) => {

    return (dispatch) => {

        dispatch(authLoading());

        // prepare the auth string
        let loginData = {
            email,
            password
        };

        if (WLID != 0) {
            loginData.wlid = WLID;
        }
        if (DID != 0) {
            loginData.did = DID;
        }
        if (ADID != 0) {
            loginData.adid = ADID;
        }

        // login our user
        axios.post(API_URL+'/api/login', loginData)
            .then(function(res) {
                if (res.data.access_token) {
                    
                    window.localStorage.removeItem("currentOrderKey");
                    dispatch(authSuccess(res.data.access_token, res.data.userInfo));
                    setAuthHeader();

                    // update cart information
                    dispatch(cartInfoUpdate({prop: 'name', value: (res.data.userInfo.first_name + " " + res.data.userInfo.last_name).trim()})); 
                    dispatch(cartInfoUpdate({prop: 'phone', value: res.data.userInfo.phone}));
                    dispatch(cartInfoUpdate({prop: 'email', value: res.data.userInfo.email}));
 
                    if (redirectTo) {
                        dispatch(setCartPanel(redirectTo));
                        history.push('/'+sitename+'/'+location_id+'/cart');
                    }
                }
                else {
                    dispatch(authError(res.data.errorMessage));
                }
            })
            .catch(function(err) {
                if (err.response.status == 401) {

                    // invalid login creds
                    dispatch(authError("Invalid credentials supplied."));
                }
                else {
                    console.log(err.response)
                    dispatch(authError("We're sorry, but there was an issue with logging in. Please try again shortly."));
                }
            });
    };
};

export const registerUser = ({ name, email, phone, password, password_confirm,  navigation }) => {

    return (dispatch) => {

        dispatch(authLoading());

        // prepare the auth string
        let registerData = {
            name,
            email,
            phone,
            password,
            password_confirm
        };

        if (WLID != 0) {
            registerData.wlid = WLID;
        }
        if (DID != 0) {
            registerData.did = DID;
        }
        if (ADID != 0) {
            registerData.adid = ADID;
        }

        // login our user
        axios.post(API_URL+'/api/register', registerData)
            .then(function(res) {

                if (res.data.status == "success") {

                    window.localStorage.removeItem("currentOrderKey");
                    dispatch(authSuccess(res.data.data.token, res.data.data.userInfo));
                    setAuthHeader();
                    navigation.goBack();
                }
                else {
                    dispatch(authError(res.data.errorMessage));
                }
            })
            .catch(function(err) {
                console.log(err.response);
                console.log(err);
                if (err.response.status == 422) {
                    dispatch(authError(err.response.data.message));
                }
                else {
                    dispatch(authError("We're sorry, but there was an issue with registration. Please try again shortly."));
                }
            });
    };
};

export const resetPassword = (email, sitename, lid) => {

    return (dispatch) => {

        dispatch(authLoading());

        // prepare the auth string
        let resetData = {
            email,
            source: 'online',
            sitename,
            lid
        };

        if (WLID != 0) {
            resetData.wlid = WLID;
        }
        if (DID != 0) {
            resetData.did = DID;
        }
        if (ADID != 0) {
            resetData.adid = ADID;
        }

        // login our user
        axios.post(API_URL+'/api/forgotpassword', resetData)
            .then(function(res) {

                if (res.data.status == "success") {
                    
                    dispatch(resetPasswordSuccess());
                }
                else {
                    dispatch(authError(res.data.message));
                }
            })
            .catch(function(err) {
                dispatch(authError("We're sorry, but there was an issue with your request. Please try again shortly."));
            });
    };
};

export const logout = () => {
    
    // remove the stored token
    window.localStorage.removeItem("c2o.token");
    setAuthHeader();
    return {
        type: 'AUTH_LOGOUT'
    };
};

export const setDefaultAddress = (token, address_id) => {
    
    return (dispatch) => {

        dispatch(authLoading());

        axios.post(API_URL+'/api/defaultaddress/update', { token, aid: address_id })
            .then(function(res) {

                if (res.data.status == "success") {
                    dispatch(authUpdateUserAddresses(res.data.data.addresses));
                    dispatch(authUserUpdate({ prop: 'defaultAddress', value: res.data.data.address }));
                    dispatch(authUserUpdate({ prop: 'defaultAddressInstructions', value: res.data.data.instructions }));
                    dispatch(authUserUpdate({ prop: 'hasDefaultAddress', value: true }));
                    
                    dispatch(authLoadingOff());
                    dispatch(setAccountPanel('info'));
                }
                else {
                    dispatch(deliveryAddressFormError(res.data.data.message));
                    alert(res.data.message);
                }
            })
            .catch(function(err) {

                console.log("Error!");
                console.log(err);
                console.log(err.response);
                
                // @TODO: what do we do here?
                dispatch(deliveryAddressFormError("We're sorry, but there was an issue with logging in. Please try again shortly."));
            });

    };
};

export const addDeliveryAddress = ({ token, address, instructions = '', lat = 0.0, lng = 0.0 }) => {
    
    return (dispatch) => {

        dispatch(deliveryAddressFormLoading());

        let params = {
            token,
            address,
            instructions,
            lat,
            lng
        };

        // prepare the params
        if (WLID != 0) {
            params.wlid = WLID;
        }
        if (DID != 0) {
            params.did = DID;
        }
        if (ADID != 0) {
            params.adid = ADID;
        }

        // attempt to update the information
        axios.post(API_URL+'/api/addresses/add', params)
            .then(function(res) {

                if (res.data.status == "success") {

                    // A successful outcome, update the information and pop back twice
                    dispatch(authUpdateUserAddresses(res.data.data.addresses));
                    dispatch(authUserUpdate({ prop: 'defaultAddress', value: address }));
                    dispatch(authUserUpdate({ prop: 'defaultAddressInstructions', value: res.data.data.instructions }));
                    dispatch(authUserUpdate({ prop: 'hasDefaultAddress', value: true }));

                    dispatch(deliveryAddressFormReset());
                    dispatch(setAccountPanel('info'));
                }
                else {
                    dispatch(deliveryAddressFormError(res.data.message));
                }
            })
            .catch(function(err) {
                console.log(err);
                console.log(err.response);
                dispatch(deliveryAddressFormError("We're sorry, but there was an issue with updating your user info. Please try again shortly."));
            });
    };
};

export const setDefaultPayment = (token, cid) => {
    
    return (dispatch) => {

        dispatch(authLoading());

        axios.post(API_URL+'/api/defaultpayment/update', { token, cid })
            .then(function(res) {

                if (res.data.status == "success") {
                    dispatch(authUserUpdate({ prop: 'paymentInfo', value: res.data.data.cards }));
                    dispatch(authLoadingOff());
                }
                else {
                    dispatch(authError(res.data.message));
                    alert(res.data.message);
                }
            })
            .catch(function(err) {
                
                // @TODO: what do we do here?
                // @TODO: set this up as a toast
                dispatch(authError("We're sorry, but there was an issue updating your default payment. Please try again shortly."));
            });

    };
};

export const removePayment = (token, cid, navigation) => {
    
    return (dispatch) => {

        dispatch(authLoading());

        axios.post(API_URL+'/api/payment/remove', { token, cid })
            .then(function(res) {

                if (res.data.status == "success") {
                    
                    dispatch(authUserUpdate({ prop: 'paymentInfo', value: res.data.data.cards }));
                    dispatch(authLoadingOff());

                    if (res.data.data.cards.length <= 0) {
                        dispatch(authUserUpdate({ prop: 'hasDefaultPayment', value: false }));
                        dispatch(authUserUpdate({ prop: 'defaultPayment', value: '' }));
                    }
                }
                else {
                    dispatch(authError(res.data.message));
                    alert(res.data.message);
                }
            })
            .catch(function(err) {
                
                // @TODO: what do we do here?
                // @TODO: set this up as a toast
                dispatch(authError("We're sorry, but there was an issue removing your payment option. Please try again shortly."));
            });

    };
};

export const getCurrentOrders = ({ token }) => {

    return (dispatch) => {

        // prepare the auth string
        let authData = {
            token
        };

        if (WLID != 0) {
            authData.wlid = WLID;
        }
        if (DID != 0) {
            authData.did = DID;
        }
        if (ADID != 0) {
            authData.adid = ADID;
        }

        // login our user
        axios.post(API_URL+'/api/getCurrentOrders', authData)
            .then(function(res) {
                if (res.data.status == "Success") {
                    
                    dispatch(updateCurrentOrders(res.data.data.currentOrders));
                    if(res.data.data.currentOrders.length > 0){
                        dispatch(setHistoryPanel('current_status'));
                    }else{
                        dispatch(setHistoryPanel('list'));
                    }

                }else {
                    //dispatch(ordersError(res.data.message));
                }
            })
            .catch(function(err) {
                //dispatch(ordersError(""));
            });

    };

};

export const getCurrentOrder = (order_key, showStatusPage) => {

    return (dispatch) => {

        // prepare the auth string
        let authData = {
            order_key
        };

        // login our user
        axios.post(API_URL+'/api/order/getCurrentOrder', authData)
            .then(function(res) {
                if (res.data.status == "Success") {
                    
                    dispatch(setCurrentOrder(res.data.data.currentOrder, true));
                    if(showStatusPage){
                        dispatch(setHistoryPanel('current_status'));
                    }

                }else {
                    //dispatch(ordersError(res.data.message));
                }
            })
            .catch(function(err) {
                //dispatch(ordersError(""));
            });

    };

};

export const updateCurrentOrders = (currentOrders) => {
    return {
        type: 'UPDATE_CURRENT_ORDERS',
        currentOrders
    };
};

export const setCurrentOrder = (currentOrder, addToCurrentOrders = false) => {
    return {
        type: 'SET_CURRENT_ORDER',
        currentOrder,
        addToCurrentOrders
    };
};
